import { createContext, useContext } from 'react';
import { getThrowingDefaultContextValue } from '@shared/helpers/react.helpers';
import { MenuContextValue } from './menu.model';

export const MenuContext = createContext<MenuContextValue>(
  getThrowingDefaultContextValue(
    'Menu components must be children of <Menu />',
  ),
);

export const useMenuContext = () => useContext(MenuContext);
